/* SKORE — store behavior.
   - Shelf tags add to cart without leaving the page (Dawn cart drawer aware)
   - Floating "Head to the counter" bar
   - Cooler door tabs
   - Open / closed sign on the homepage (Mountain Time)
   Loaded once via snippets/skore-head.liquid. */
(function () {
  if (window.__skoreStore) return;
  window.__skoreStore = true;

  var TZ = 'America/Denver';
  var TIP_HANDLE = 'driver-tip';

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  function parse(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }
  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* ---------- Screen-reader announcements ---------- */
  var live;
  function announce(msg) {
    if (!live) {
      live = document.createElement('div');
      live.setAttribute('aria-live', 'polite');
      live.className = 'visually-hidden';
      live.style.cssText = 'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0)';
      document.body.appendChild(live);
    }
    live.textContent = '';
    setTimeout(function () { live.textContent = msg; }, 50);
  }

  /* ---------- Cart drawer + header bubble refresh (Dawn) ---------- */
  function refreshCartUI(sections) {
    if (!sections) return;

    var bubble = document.getElementById('cart-icon-bubble');
    if (bubble && sections['cart-icon-bubble']) {
      var b = parse(sections['cart-icon-bubble']).querySelector('.shopify-section');
      if (b) bubble.innerHTML = b.innerHTML;
    }

    var drawer = document.querySelector('cart-drawer');
    var inner = document.getElementById('CartDrawer');
    if (drawer && inner && sections['cart-drawer']) {
      var d = parse(sections['cart-drawer']).querySelector('#CartDrawer');
      if (d) {
        inner.innerHTML = d.innerHTML;
        drawer.classList.remove('is-empty');
        var di = drawer.querySelector('.drawer__inner');
        if (di) di.classList.remove('is-empty');
        var overlay = document.getElementById('CartDrawer-Overlay');
        if (overlay && typeof drawer.close === 'function') {
          overlay.addEventListener('click', drawer.close.bind(drawer));
        }
      }
    }
  }

  /* ---------- Floating bag ---------- */
  function updateBag() {
    var bag = document.querySelector('[data-skore-bag]');
    if (!bag) return;
    fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var n = 0, total = 0;
        (cart.items || []).forEach(function (it) {
          if (it.handle === TIP_HANDLE) return;
          n += it.quantity;
          total += it.final_line_price;
        });
        var c = bag.querySelector('[data-skore-bag-count]');
        var t = bag.querySelector('[data-skore-bag-total]');
        if (c) c.textContent = n;
        if (t) t.textContent = money(total);
        bag.hidden = n === 0;
      })
      .catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var bag = e.target.closest && e.target.closest('[data-skore-bag]');
    if (!bag) return;
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') {
      e.preventDefault();
      drawer.open(bag);
    }
  });

  /* ---------- Shelf tags: add to cart ---------- */
  function flash(btn, text, cls) {
    var label = btn.querySelector('[data-skore-add-label]');
    if (!label) return;
    var original = label.getAttribute('data-original') || label.textContent;
    label.setAttribute('data-original', original);
    label.textContent = text;
    btn.classList.add(cls);
    clearTimeout(btn.__skoreT);
    btn.__skoreT = setTimeout(function () {
      label.textContent = original;
      btn.classList.remove(cls);
    }, 1600);
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('[data-skore-add]')) return;
    e.preventDefault();

    var btn = form.querySelector('button[type="submit"]');
    var idInput = form.querySelector('[name="id"]');
    if (!btn || !idInput || btn.getAttribute('aria-busy') === 'true') return;
    var name = form.getAttribute('data-name') || 'Item';

    btn.setAttribute('aria-busy', 'true');

    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(idInput.value), quantity: 1 }],
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname
      })
    })
      .then(function (r) {
        return r.json().then(function (j) { return { ok: r.ok, status: r.status, body: j }; });
      })
      .then(function (res) {
        if (!res.ok) {
          var err = new Error(res.body && (res.body.description || res.body.message) || 'Could not add');
          err.status = res.status;
          throw err;
        }
        refreshCartUI(res.body.sections);
        flash(btn, 'Added', 'is-added');
        announce(name + ' added to your order.');
        updateBag();
        document.dispatchEvent(new CustomEvent('skore:added', { detail: { id: idInput.value } }));
      })
      .catch(function (err) {
        flash(btn, err.status === 422 ? 'Out of stock' : 'Try again', 'is-error');
        announce(err.status === 422 ? name + ' is out of stock.' : 'Could not add ' + name + '. Try again.');
      })
      .then(function () {
        btn.removeAttribute('aria-busy');
      });
  });

  /* ---------- Cooler door tabs ---------- */
  function initTabs(scope) {
    (scope || document).querySelectorAll('[data-skore-tabs]').forEach(function (list) {
      if (list.__skoreTabs) return;
      list.__skoreTabs = true;
      var tabs = Array.prototype.slice.call(list.querySelectorAll('[role="tab"]'));

      function select(i, focus) {
        tabs.forEach(function (t, j) {
          var on = i === j;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
        if (focus) tabs[i].focus();
      }

      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(i); });
        t.addEventListener('keydown', function (e) {
          var k = e.key, n = tabs.length;
          if (k === 'ArrowRight') { e.preventDefault(); select((i + 1) % n, true); }
          else if (k === 'ArrowLeft') { e.preventDefault(); select((i - 1 + n) % n, true); }
          else if (k === 'Home') { e.preventDefault(); select(0, true); }
          else if (k === 'End') { e.preventDefault(); select(n - 1, true); }
        });
      });

      list.__skoreSelect = function (blockId) {
        tabs.forEach(function (t, i) { if (t.getAttribute('data-block-id') === blockId) select(i); });
      };
      select(0);
    });
  }

  /* ---------- Open / closed sign ---------- */
  function hourLabel(h) {
    h = h % 24;
    if (h === 0) return 'midnight';
    if (h === 12) return 'noon';
    return h < 12 ? h + 'am' : (h - 12) + 'pm';
  }

  function nowMinutes() {
    var parts = new Intl.DateTimeFormat('en-US', {
      timeZone: TZ, hour: 'numeric', minute: 'numeric', hourCycle: 'h23'
    }).formatToParts(new Date());
    var h = 0, m = 0;
    parts.forEach(function (p) {
      if (p.type === 'hour') h = parseInt(p.value, 10) % 24;
      if (p.type === 'minute') m = parseInt(p.value, 10);
    });
    return h * 60 + m;
  }

  function initHours(scope) {
    (scope || document).querySelectorAll('[data-skore-hours]').forEach(function (el) {
      if (el.__skoreHours) clearInterval(el.__skoreHours);
      var open = parseInt(el.getAttribute('data-open'), 10) * 60;
      var close = parseInt(el.getAttribute('data-close'), 10) * 60;
      var openLine = el.getAttribute('data-open-line') || '';
      var sign = el.querySelector('[data-skore-hours-sign]');
      var line = el.querySelector('[data-skore-hours-line]');
      if (isNaN(open) || isNaN(close) || open === close) return;

      function tick() {
        var now = nowMinutes();
        var isOpen, left;
        if (close > open) {
          isOpen = now >= open && now < close;
          left = close - now;
        } else {
          isOpen = now >= open || now < close;
          left = now < close ? close - now : close + 1440 - now;
        }
        el.classList.toggle('is-closed', !isOpen);
        if (sign) sign.textContent = isOpen ? 'Open' : 'Closed';
        if (!line) return;
        if (!isOpen) line.textContent = 'Opens at ' + hourLabel(open / 60) + '.';
        else if (left <= 30) line.textContent = 'Last call: order in the next ' + left + ' min.';
        else line.textContent = openLine;
      }
      tick();
      el.__skoreHours = setInterval(tick, 60000);
    });
  }

  function init(scope) {
    initTabs(scope);
    initHours(scope);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  /* Theme editor */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var list = e.target.closest('.skore-section') && e.target.closest('.skore-section').querySelector('[data-skore-tabs]');
    if (list && list.__skoreSelect) list.__skoreSelect(e.detail.blockId);
  });
})();
